﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_infoScreen from './tpl/infoScreen.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_infoScreen({  });
    },
    initialize: function () {
        this.app = this.options.app;
    },
    onBeforeShow: function () {
    },
    ui: {
    },
    events: {
    },
    onRender: function () {
    },
    onAttach(){
    },
    onDestroy(){
    }
}, Backbone.Radio.Requests);
